module.exports = __webpack_public_path__ + "img/case_13.9980d755.png";